import { render } from "./TableHeadRow.vue?vue&type=template&id=2f7c8578&ts=true"
import script from "./TableHeadRow.vue?vue&type=script&lang=ts"
export * from "./TableHeadRow.vue?vue&type=script&lang=ts"

import "./TableHeadRow.vue?vue&type=style&index=0&id=2f7c8578&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__